import { Typography } from '@mui/material';
import dayjs from 'dayjs';

export const formatLastUpdatedCell = (editedAt?: string | null, editedBy?: string | null) => {
  if (!editedAt) {
    return '—';
  }

  return (
    <>
      <Typography sx={{ fontSize: '0.8125rem', fontWeight: 600, lineHeight: 1.35 }}>
        {dayjs(editedAt).format('D MMM YYYY')}
      </Typography>
      <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary', lineHeight: 1.35 }}>
        {dayjs(editedAt).format('h:mm A')}
      </Typography>
      {editedBy ? (
        <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary', lineHeight: 1.35 }}>
          by {editedBy}
        </Typography>
      ) : null}
    </>
  );
};

export const lastUpdatedTableColumn = (headerName = 'Last Updated') => ({
  field: 'editedAt',
  headerName,
  flex: 3,
  sortable: true,
  renderCell: (_value: any, row: { editedAt?: string | null; editedBy?: string | null }) =>
    formatLastUpdatedCell(row.editedAt, row.editedBy),
});
